var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 15.0625C16.2205 15.0625 19.3125 11.9705 19.3125 8.15625C19.3125 4.34203 16.2205 1.25 12.4062 1.25C8.59203 1.25 5.5 4.34203 5.5 8.15625C5.5 11.9705 8.59203 15.0625 12.4062 15.0625Z",
    stroke: "#03212B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 25.6875C1.25 20.375 5.5 15.0625 12.4062 15.0625C19.3125 15.0625 23.5625 20.375 23.5625 25.6875",
    stroke: "#03212B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq1);
export default __webpack_public_path__ + "static/media/faq1.770442410876a7d024c597d24471825d.svg";
export { ForwardRef as ReactComponent };